import React from 'react';
import { Flex, FormLabel, Switch } from '@tapresearch/ui/components';
export var HideEmptySwitch = function(param) {
    var isHiding = param.isHiding, isSwitching = param.isSwitching, setIsHiding = param.setIsHiding;
    return /*#__PURE__*/ React.createElement(Flex, {
        "data-testid": "hide-empty-switch-container",
        align: "center",
        lineHeight: "8",
        justify: "flex-end",
        mt: 4
    }, /*#__PURE__*/ React.createElement(FormLabel, {
        m: 0,
        fontWeight: "normal",
        fontSize: "sm",
        lineHeight: "normal"
    }, "Hide empty results:"), /*#__PURE__*/ React.createElement(Flex, {
        w: "45px",
        justify: "flex-end"
    }, /*#__PURE__*/ React.createElement(Switch, {
        "data-testid": "hide-empty-switch",
        isChecked: isHiding,
        isDisabled: isSwitching,
        onChange: function() {
            return setIsHiding(!isHiding);
        },
        ml: 2
    })));
};
